import gql from 'graphql-tag';

export const NAME = 'compositions_CaseAssetValidationPanel_validateAssetQuery';

export default gql`
  query ${NAME} ($caseId: ID!, $input: ValidateAssetResponseAssetInput!) {
    validateAsset (caseId: $caseId, input: $input) {
      user {
        name
        email
      }
      reference
      timestamp
      assets {
        shipTo
        customer
        vehicleVin
        application
        vehicleType
        vehicleNumber
        domicileLocation
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseAssetValidationPanel/withCaseAssetValidation/validateAssetQuery.js